/**
 * Normalise a raw domain or email into a bare hostname (no protocol, no www,
 * no path). Returns null if nothing usable can be derived.
 *
 * Lives here rather than beside the research tool because both sides need it:
 * the server derives the domain it researches, and the client prefills and
 * validates the domain the recruiter confirms before a re-run.
 */
export function normaliseDomain(domainOrEmail: unknown): string | null {
  if (!domainOrEmail || typeof domainOrEmail !== "string") return null;

  let value = domainOrEmail.trim().toLowerCase();
  if (!value) return null;

  // Derive the domain from an email address if one was passed.
  if (value.includes("@")) {
    value = value.split("@").pop() as string;
  }

  // Strip protocol, any path/query, and a leading www.
  value = value
    .replace(/^[a-z]+:\/\//, "")
    .split("/")[0]
    .split("?")[0]
    .replace(/^www\./, "")
    .trim();

  // Basic sanity check: must look like a domain (has a dot, no spaces).
  if (!value || value.includes(" ") || !value.includes(".")) return null;

  return value;
}

export default normaliseDomain;
